export const FeatureToggles = {
	ENABLE_COMMENTS: true,
};
